function _(e,a,r){var t=e(406);r.CanvasTexture=t.CanvasTexture;var u=e(408);r.ImageURLTexture=u.ImageURLTexture;var x=e(407);r.Texture=x.Texture}
//# sourceMappingURL=index.min.js.map